import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const MarqueeTent = () => {
  const [activeImage, setActiveImage] = useState(0);

  const facilityData = {
    name: 'Marquee Tent',
    category: 'Events',
    description: 'Versatile covered space for outdoor events and gatherings.',
    longDescription: 'Our elegant marquee tent provides a unique outdoor venue that combines the beauty of nature with the comfort of covered space. Perfect for weddings, corporate functions, and special celebrations, the tent can be configured in various layouts to suit your needs. With climate control and professional lighting, it offers a magical setting for any occasion.',
    images: [
      getImagePath('images/bars/marquee-tent.jpg'),
      getImagePath('images/bars/marquee-tent.jpg'),
      getImagePath('images/bars/marquee-tent.jpg')
    ],
    icon: 'fa-campground',
    capacity: '200 guests',
    hours: 'By appointment | Events: 24hrs',
    features: [
      'Climate Control',
      'Professional Lighting',
      'Flexible Layout',
      'Dance Floor',
      'Stage Area',
      'Catering Setup',
      'Generator Backup',
      'Decoration Options'
    ],
    amenities: ['Parking', 'Restrooms Nearby', 'Power Supply', 'Event Coordination'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'events@nlngraclub.com',
      extension: '109'
    },
    configurations: ['Theater Style', 'Banquet Style', 'Cocktail Style', 'Classroom Style'],
    occasions: ['Weddings', 'Corporate Events', 'Galas', 'Parties']
  };

  return (
    <div className="facility-detail-page">
      {/* Hero Section */}
      <section className="facility-detail-hero">
        <div className="hero-background">
          <img src={facilityData.images[0]} alt={facilityData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/facilities" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Facilities
            </Link>
            <span className="facility-category">{facilityData.category}</span>
            <h1 className="facility-title">{facilityData.name}</h1>
            <p className="facility-subtitle">{facilityData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Facility Content */}
      <section className="facility-content-section">
        <div className="container">
          <div className="facility-grid">
            {/* Left Column - Images */}
            <div className="facility-gallery">
              <div className="main-image">
                <img 
                  src={facilityData.images[activeImage]} 
                  alt={facilityData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {facilityData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${facilityData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="facility-details">
              <div className="detail-section">
                <h2>About {facilityData.name}</h2>
                <p className="facility-description">{facilityData.longDescription}</p>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {facilityData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <h4>Hours</h4>
                  <p>{facilityData.hours}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <h4>Capacity</h4>
                  <p>{facilityData.capacity}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-phone"></i>
                  <h4>Contact</h4>
                  <p>{facilityData.contact.phone} ext. {facilityData.contact.extension}</p>
                </div>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Configurations:</span>
                  <span className="info-value">{facilityData.configurations.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Perfect for:</span>
                  <span className="info-value">{facilityData.occasions.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-calendar-check"></i> Book This Venue
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-envelope"></i> Event Inquiry
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MarqueeTent;